(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oku-aube"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oku-aube')) {
    customElements.define(
      'oku-aube',
      class OkuAube extends HTMLElement {
        connectedCallback() {
          if (!this.hasAttribute('data-anime')) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          const jour = this.querySelector('.oku-aube__jour');
          if (!jour) return;
          const lever = () => {
            requestAnimationFrame(() => {
              window.setTimeout(() => this.classList.add('is-levee'), 600);
            });
          };
          if (jour.complete && jour.naturalWidth > 0) {
            lever();
          } else {
            jour.addEventListener('load', lever, { once: true });
          }

          if (!this.hasAttribute('data-boucle')) return;
          const pause = this.querySelector('.oku-aube__pause');
          if (pause) {
            pause.hidden = false;
            pause.addEventListener('click', () => {
              const enPause = this.classList.toggle('est-en-pause');
              pause.setAttribute('aria-label', enPause ? "Relancer l'animation" : "Mettre l'animation en pause");
            });
          }
          this.observateur = new IntersectionObserver(([entree]) => {
            this.classList.toggle('hors-ecran', !entree.isIntersecting);
          });
          this.observateur.observe(this);
        }

        disconnectedCallback() {
          this.observateur?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oku-carte-cadeau"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oku-carte-cadeau')) {
    customElements.define(
      'oku-carte-cadeau',
      class OkuCarteCadeau extends HTMLElement {
        connectedCallback() {
          const section = this.closest('.oku-carte');
          this.querySelectorAll('[data-cible]').forEach((champ) => {
            const rendu = section.querySelector(`[data-rendu="${champ.dataset.cible}"]`);
            const defaut = rendu.textContent;
            champ.addEventListener('input', () => {
              rendu.textContent = champ.value.trim() || defaut;
            });
          });
          this.querySelector('[data-imprimer]')?.addEventListener('click', () => window.print());
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oku-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oku-video')) {
    customElements.define(
      'oku-video',
      class OkuVideo extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          this.bouton = this.querySelector('.oku-video__bouton');
          if (!this.video) return;

          this.video.muted = true;
          this.pauseVolontaire = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.charge = false;

          this.bouton?.addEventListener('click', () => this.basculer());

          // Vignette chargée à l'approche seulement : elle ne concurrence pas la photo principale au chargement
          this.observateurVignette = new IntersectionObserver(
            (entrees) => {
              if (!entrees.some((entree) => entree.isIntersecting)) return;
              if (this.video.dataset.poster) this.video.poster = this.video.dataset.poster;
              this.observateurVignette.disconnect();
            },
            { rootMargin: '800px 0px' }
          );
          this.observateurVignette.observe(this);

          this.observateur = new IntersectionObserver(
            (entrees) => {
              for (const entree of entrees) {
                if (entree.isIntersecting) {
                  this.charger();
                  if (!this.pauseVolontaire) this.lire();
                } else if (this.charge) {
                  this.video.pause();
                }
              }
            },
            { rootMargin: '200px 0px' }
          );
          this.observateur.observe(this);
          this.majBouton();
        }

        disconnectedCallback() {
          this.observateur?.disconnect();
          this.observateurVignette?.disconnect();
        }

        charger() {
          if (this.charge) return;
          this.charge = true;
          for (const source of this.video.querySelectorAll('source[data-src]')) {
            source.src = source.dataset.src;
          }
          this.video.load();
          if (this.bouton) this.bouton.hidden = false;
        }

        lire() {
          const promesse = this.video.play();
          if (promesse) promesse.catch(() => this.majBouton(true));
          this.majBouton(false);
        }

        basculer() {
          if (this.video.paused) {
            this.pauseVolontaire = false;
            this.charger();
            this.lire();
          } else {
            this.pauseVolontaire = true;
            this.video.pause();
            this.majBouton(true);
          }
        }

        majBouton(enPause = this.pauseVolontaire) {
          this.classList.toggle('est-en-pause', enPause);
          if (this.bouton) {
            this.bouton.setAttribute('aria-label', enPause ? 'Lire la vidéo' : 'Mettre la vidéo en pause');
            if (enPause) this.bouton.hidden = false;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
